import api from '@/api';
import { isValidBrowser } from '@/compatibility-detection';

const cookiesHandler = {
    set: (name = '', data = {}, minutes = 30) => {
        const date = new Date(new Date().getTime() + minutes * 60000)
        const expires = "; expires=" + date.toUTCString();
        const handled = typeof data === 'object' ? JSON.stringify(data) : data;

        document.cookie = `${name}=${handled}${expires}; path=/`;
    },
    get: (name = '') => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);

        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        };

        return null;
    },
};

const ignores = {
    ignoreErrors: [
        // Random plugins/extensions
        'top.GLOBALS',  
        // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
        'originalCreateNotification',
        // Random http failures
        'Failed to fetch',
        "Can't find variable: handleDesktopPreviewer",
        "Can't find variable: handleMobilePreviewer",
        /Can't find variable: .+/,
        /^.+ is not defined$/,
        'UnknownErrorException',
        'Permission denied to access property "nodeType"',
    ],
    denyUrls: [
        // Google Adsense
        /pagead\/js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        /^chrome-extension:\/\//i,
        // Other extensions
        /webkit-masked-url/i,
        // Avoid sentry reporting from interactive tools usage
        /^.*\/interactive-therapy-tool\/[a-z\-]+\/active(\?.*)?$/i,
        /^.*\/activity\/[a-z\-]+\/active(\?.*)?$/i,
        /^.*\/story\/[a-z\-]+\/active(\?.*)?$/i,
        /^.*\/audio\/[a-z\-]+\/active(\?.*)?$/i,
    ],
    beforeSend: (event) => {
        if (ignores.denyUrls.some(regex => new RegExp(regex).test(window.location.href))) {
            return null;
        }

        if(event?.exception && event.exception?.values.length > 0) {
            if(typeof Array.prototype.flatMap === 'undefined'){
                return null;
            }

            const frames = event.exception.values.flatMap((exception) => exception?.stacktrace?.frames);
            const validFrames = frames.filter(frame => frame?.filename && frame?.function);

            if (validFrames.length <= 2) {
                return null;
            }
        }

        if(!isValidBrowser()){
            return null;
        }

        try {
            window.localStorage
        } catch (e) {
            return null;
        }

        return event;
     },
    beforeBreadcrumb: (breadcrumb, hint) => {
        if(typeof breadcrumb?.message === 'string' && breadcrumb?.message?.includes('Successfully registered service worker')){
          return null;
        }

        return breadcrumb;
    },
    beforeSendTransaction: async (transaction) => {
        try {
            const stored = cookiesHandler.get('has-enabled-transactions');

            if(stored) {
                const hasEnabledFromStore = stored && JSON.parse(stored);
                return hasEnabledFromStore?.feature ? transaction : null;
            }

            const { data } = await api.get('has-feature-flag', { params: { feature: 'SENTRY_TRANSACTIONS' } });

            cookiesHandler.set('has-enabled-transactions', data);

            const { feature } = data;

            return feature ? transaction : null;
        } catch (e){
            console.error(e);
            return transaction;
        }
    },
};

export default ignores;
